import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-5",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi-bar-chart-fill text-danger p-3" }),
    /*#__PURE__*/_createElementVNode("h5", { class: "fw-bolder m-0" }, "Savings V Budget")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "overlay-wrapper" }
const _hoisted_5 = { class: "row mb-7" }
const _hoisted_6 = { id: "chart" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark-o-25" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner spinner-primary" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'overlay overlay-block': _ctx.loading })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_apexchart, {
                ref: "chart",
                type: "bar",
                height: "350",
                options: _ctx.chartOptions,
                series: _ctx.series
              }, null, 8, ["options", "series"])
            ])
          ])
        ]),
        _hoisted_7
      ])
    ])
  ], 2))
}